import { AttributeValuesDto } from './attributeValuesDto';
import { SiteDto } from './siteDto';
import { UserDto } from './userDto';
import { CulturalRouteAvailability } from './culturalRouteAvailability';

export class CulturalRoute{
    id;
    culturalRouteTranslations;
    availabilities: CulturalRouteAvailability[];
    attributeValues: AttributeValuesDto[];
    user: UserDto;
    duration:number;
    language: string;
    image:string;
}